import React from 'react';
export function Footer() {
  return <footer id="contacto" className="bg-texto text-crema pt-20 pb-10" data-id="element-100">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-101">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-102">
          {/* Brand */}
          <div className="md:col-span-2" data-id="element-103">
            <h2 className="font-serif text-4xl mb-6" data-id="element-104">Habitando mi cuerpo.</h2>
            <p className="font-sans text-crema/70 max-w-md leading-relaxed" data-id="element-105">
              Un espacio para conocer tu cuerpo desde un lugar humano, emocional
              y estético. Ebooks y recursos digitales para acompañarte.
            </p>
          </div>

          {/* Links */}
          <div data-id="element-106">
            <h3 className="font-sans font-bold tracking-widest text-xs uppercase text-crema/50 mb-6" data-id="element-107">
              Navegación
            </h3>
            <ul className="space-y-4 font-sans text-crema/80" data-id="element-108">
              <li data-id="element-109">
                <a href="#inicio" className="hover:text-rosa transition-colors" data-id="element-110">
                  Inicio
                </a>
              </li>
              <li data-id="element-111">
                <a href="#ebooks" className="hover:text-rosa transition-colors" data-id="element-112">
                  Ebooks
                </a>
              </li>
              <li data-id="element-113">
                <a href="#temas" className="hover:text-rosa transition-colors" data-id="element-114">
                  Temas
                </a>
              </li>
              <li data-id="element-115">
                <a href="#nosotros" className="hover:text-rosa transition-colors" data-id="element-116">
                  Sobre la marca
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div data-id="element-117">
            <h3 className="font-sans font-bold tracking-widest text-xs uppercase text-crema/50 mb-6" data-id="element-118">
              Conectar
            </h3>
            <ul className="space-y-4 font-sans text-crema/80" data-id="element-119">
              <li data-id="element-120">
                <a href="#" className="hover:text-rosa transition-colors" data-id="element-121">
                  Contacto
                </a>
              </li>
              <li data-id="element-122">
                <a href="#" className="hover:text-rosa transition-colors" data-id="element-123">
                  Instagram
                </a>
              </li>
              <li data-id="element-124">
                <a href="#" className="hover:text-rosa transition-colors" data-id="element-125">
                  Aviso legal
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-crema/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left" data-id="element-126">
          <p className="font-sans text-xs text-crema/40 max-w-2xl" data-id="element-127">
            Aviso importante: El contenido de nuestros ebooks es estrictamente
            informativo y de acompañamiento emocional. No reemplaza en ningún
            caso la atención, diagnóstico o tratamiento de profesionales médicos
            o psicológicos.
          </p>
          <p className="font-sans text-xs text-crema/40 whitespace-nowrap" data-id="element-128">
            © {new Date().getFullYear()} Cuerpa. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}